module.exports = __webpack_public_path__ + "static/media/loc7_img13.0f8aa4e1.jpg";